/*
 * @Date: 2022-07-04 10:09:06
 * @LastEditors: guantingting
 * @LastEditTime: 2023-03-21 14:36:20
 */

export default [
  {
    path: '/rent/v2/tool/webBri',
    name: 'webBridge',
    component: () => import('@/pages/toolPage/webBri'),
    meta: { title: ' ', requireAuth: true },
  },
  {
    path: '/rent/v2/tool/showMap',
    name: 'showMap',
    component: () => import('@/pages/toolPage/showMap'),
    meta: { title: '地图', requireAuth: true },
  }
]


// WEBPACK FOOTER //
// ./src/pages/toolPage/tool.js